module.exports = __webpack_public_path__ + "img/meet-transfer-service.4aaa8a3b.svg";